<div class="dashboard--module-header">
    <h2 class="subheading-sm">No Consumption in last 30 days<button class="info-btn focus-element" (click)="onInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
</div>
<div class="module--main">
    <issues-no-consumption-chart class="block-chart"></issues-no-consumption-chart>
    <div class="block-detail">
        <table class="std-table stacked-sm" *ngIf="data.length > 0">
            <thead>
            <th>Consumer name</th>
            <th>Supply address</th>
            <th>Supply</th>
            <th>Meter ID</th>
            <th>Last date of consumption</th>
            <th>Banding</th>
            </thead>
            <tbody>
                <tr *ngFor="let item of data">
                    <td data-label="Consumer name">{{item.consumerName}}</td>
                    <td data-label="Supply address">{{item.meterAddress}}</td>
                    <td data-label="Supply">{{item.supplyCategory}}</td>
                    <td data-label="Meter ID">{{item.serialNumber}}</td>
                    <td data-label="Last date of consumption">{{item.lastDateOfConsumption | date:'dd/MM/yyyy'}}</td>
                    <td data-label="Banding">{{item.noConsumptionBanding}}</td>
                    <td class="text-right" *ngIf="clientId !== null"><a [routerLink]="['/portal/'+ clientId +'/consumer',item.consumerId]" class="text-link focus-element" *ngIf="clientId !== null"><span class="focus--content">View</span></a></td>
                </tr>
            </tbody>
        </table>
        <app-pagination *ngIf="data.length > 0" [page]="page" [pages]="totalPages" (pageChange)="getPage($event)"></app-pagination>
    </div>
</div>
